export default __webpack_public_path__ + "static/media/Yawning.896bbb91.svg";